module.exports = __webpack_public_path__ + "static/media/FriendlyCatchUp.383ddce2.jpg";